/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-08-02 17:31:39
 * @LastEditors: pingping.mao
 * @LastEditTime: 2022-12-29 11:10:31
 */
import request from "@/utils/request";
const requestUrl = `${window.env.scimSystem}/api/v1`;
const api = {
  getDatabaseList: params => request({
    url: `${requestUrl}/datasource`,
    method: "get",
    params
  }),
  getDatabaseFormById: params => request({
    url: `${requestUrl}/datasource/${params.id}/table`,
    method: "get",
    params
  }),
  getFormFieldById: params => request({
    url: `${requestUrl}/datasource/${params.id}/table/${params.tableName}/field`,
    method: "get",
    params
  }),
  executeSql: ({ id, ...arg }) => request({
    url: `${requestUrl}/datasource/${id}/sql/execute`,
    method: "post",
    data: arg
  })
};
export default api;
